import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=51f70d22&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=ts&"
export * from "./BarChart.vue?vue&type=script&lang=ts&"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=51f70d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f70d22",
  null
  
)

export default component.exports